import type { RouteLocationRaw } from 'vue-router';
import { merge } from 'lodash-es';
import { toRef } from 'vue';

import { isString } from '@utils/guards';

import { useMerchantIdStore } from '../store';

export default function useAddMerchantIdToRoute() {
  const merchantId = toRef(useMerchantIdStore(), 'merchantId');

  function addMerchantId(route: RouteLocationRaw): RouteLocationRaw {
    return isString(route) ? route : merge(route, { query: { merchant: merchantId.value } });
  }

  function mixMerchantIdIntoRoute<T extends { route?: RouteLocationRaw }>(item: T): T {
    return {
      ...item,
      route: item.route ? addMerchantId(item.route) : item.route,
    };
  }

  return {
    addMerchantId,
    mixMerchantIdIntoRoute,
  };
}
